// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1uqzH","dragIcon":"SortableItem_dragIcon__2Cjkq","disabled":"SortableItem_disabled__1KzGM"};